/**
 *
 * key
 *
 */

 const key = 'Ym9va2luZw=='

 export default key
 